module.exports = __webpack_public_path__ + "static/media/5.cdfe3d28.jpg";